import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedNew202510: FaireAdPerformancePeriodEntity = {
  token: "perf_p4_under_utilized_new_202510",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-10-01",
  endDate: "2025-10-31",
  impressions: 23356,
  clicks: 391,
  adsSpendDollars: 1476,
  budgetDollars: 14500,
  salesDollars: 18492,
  bestEstimateRoas: 12.53,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.1,
  newCustomersAcquired: 17,
  dataAvailableAtDate: "2025-11-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
